import { iots } from '@code-expert/prelude';
import { CourseUrl, SemesterId } from '/imports/domain';

export const pageKeys = {
  analytics: null,
  codeExamples: null,
  exercises: null,
  groups: null,
};

export const Page = iots.keyof(pageKeys);
export type Page = keyof typeof pageKeys;

export const EnroledPageParams = iots.struct(
  {
    semester: SemesterId,
    courseUrl: CourseUrl,
  },
  {
    page: Page,
  },
);

export type EnroledPageParams = iots.TypeOf<typeof EnroledPageParams>;

export const defaultPage: Page = 'exercises';
